export default "__VITE_ASSET__rajkwiD8__"